import ConsultaBase from "../shared/ConsultaBase";
import { cotherm4compConsultaConfig } from "../config/cotherm4compConsulta";

const CCoTherm4Comp = () => {
  return <ConsultaBase config={cotherm4compConsultaConfig} />;
};

export default CCoTherm4Comp;